import { Action } from "./SkidsProvider"
export function addSkid(skids:Set<string>,action:Action):Set<string>{
    skids.add(action.skid)
    return skids
}
export function addSkids(skids:Set<string>,action:Action):Set<string>{
    //console.log('Adding Skids:',action.skids)
    //console.log('Current Skids:',skids)
    //console.log('Skids type:',typeof action.skids)
     if (!skids){
        return new Set(action.skids)
    }
    if(skids.size === 0){
        return new Set(action.skids)
    }
    action.skids.forEach((skid)=>{
        skids.add(skid)
    })
    return skids
}
export function removeSkid(skids:Set<string>,action:Action):Set<string>{
    skids.delete(action.skid)
    return skids
}
export function removeSkids(skids:Set<string>,action:Action):Set<string>{
    action.skids.forEach((skid)=>{
        skids.delete(skid)
    })
    return skids
}
export function clearSkids(skids:Set<string>):Set<string>{
    skids.clear()
    return skids
}

export function isPopulated(state:Set<string>|Map<string,any>){
    if (!state){
        //console.log(state,"is not populated")
        return false
    }
    if (state.size === 0){
      //  console.log(state,"is not populated")
        return false
    }
    //console.log(state,"is populated")
    return true
}

export function toSelectOptions(state:Set<string>){
    if (isPopulated(state)){
        return Array.from(state)
    }else 
        return []
}
 export function mapToSelectOptions(state:Map<string,any>):Array<string>{
    if (isPopulated(state)){
        //console.log("returning keys")
        return  [...state.keys()]
    }else 
        //console.log("returning empty array")
        return []
 }